import { Image } from "theme-ui";
import moneyImg from "../../../../src/images/money.jpg";
import * as React from 'react';
export default {
  Image,
  moneyImg,
  React
};